import React from "react";
import { IconButton, useColorMode } from "@chakra-ui/react";
import { SunIcon, MoonIcon } from "@chakra-ui/icons";

export const ThemeToggle: React.FC = () => {
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <IconButton
      aria-label="Toggle theme"
      icon={
        colorMode === "light" ? (
          <MoonIcon fontSize="20px" />
        ) : (
          <SunIcon fontSize="20px" />
        )
      }
      onClick={toggleColorMode}
      variant="ghost"
      w="auto"
    />
  );
};

export default ThemeToggle;
